module.exports = __webpack_public_path__ + "img/reference64.f6d2e975.jpg";